import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { responseStatus } from '../const/responseStatus.const';
import { ToasterService } from '../services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { generateRandomString } from '../helpers/generateRandomString.helper';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GetInterceptorService implements HttpInterceptor {
  private platFormId = inject(PLATFORM_ID);
  constructor(
    private router: Router,
    private _toastrService: ToasterService,
    private _translateService: TranslateService,
    private _authService: AuthService
  ) {}
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // ToDo
          }
        },
        error: (error: HttpErrorResponse) => {
          // console.log(error, 'error');
          switch (error['status']) {
          case responseStatus.BADREQUEST: {
            this._toastrService.errToastr(error['error']['message']);
            break;
          }
          case responseStatus.UNAUTHORIZED: {
            if (isPlatformBrowser(this.platFormId)) {
              // this._toastrService.errToastr(error['error']['message']);
              localStorage.clear();
              this.router.navigate(['/home-v2']);
              const availableInSession = sessionStorage.getItem(
                environment.guestTokenKey
              );

              if (!availableInSession) {
                sessionStorage.setItem(
                  environment.guestTokenKey,
                  generateRandomString(10)
                );
              }
              this._authService.profileDetails.next(null);
            }
            break;
          }
          case responseStatus.FORBIDDEN: {
            if (isPlatformBrowser(this.platFormId)) {
              this._toastrService.errToastr(error['error']['message']);
              localStorage.clear();
              this.router.navigate(['/home-v2']);
            }
            break;
          }
          case responseStatus.REQUESTTIMEOUT: {
            this._toastrService.errToastr(error['error']['message']);
            break;
          }
          case responseStatus.INTERNALSERVERERROR:
            this._toastrService.errToastr(error['error']['message']);
            break;
          default:
            this._toastrService.errToastr(
              this._translateService.instant('networkConnection')
            );
          }
        }
      })
    );
  }
}
